
import {
  defineComponent,
  reactive,
  ref,
} from 'vue'
import axios from 'axios'
import { Message as ElMessage } from 'element-ui'
import { getGraphApi, getKeyWordApi, getAbstractApi } from '@/api/nlp/nlp-api'
import type { IFileRead } from '@/api/nlp/nlp-api-type'
import ThemeWords from '@/views/NLP/components/ThemeWords.vue'
import { IS_DEV } from '@/const'
import FileList from '@/views/NLP/components/FileList.vue'
import AbstractCard from '@/views/NLP/components/AbstractCard.vue'
import GraphCard from '@/views/NLP/components/GraphCard.vue'

const CancelToken = axios.CancelToken

export default defineComponent({
  components: {GraphCard, AbstractCard, FileList, ThemeWords},
  setup () {
    const selectFileIds = ref<string[]>(['123'])
    const nlpResult = reactive<IFileRead.INlpResult>({
      themeWords: [],
      graph: {
        nodes: [],
        links: [],
      }, // TODO: 图的 ts 类型改为 obj
      abstract: '',
    })

    function startNlpTask (ids:Array<string>) {
      selectFileIds.value = ids
      if (selectFileIds.value.length === 0) {
        ElMessage.error('您还未对文件进行过文件解读')
        return
      }
      updateGraph(500)
      onUpdateAbstractCount(paramsOfAbstract.summaryCount)
      onUpdateThemeWordCount(paramsOfThemeWord.keywordCount)
    }

    const graphIsLoading = ref(false)

    let cancelTokenOfGraphApi = CancelToken.source()
    function updateGraph (graphCount: number) {
      graphIsLoading.value = true
      cancelTokenOfGraphApi.cancel()
      cancelTokenOfGraphApi = CancelToken.source()
      getGraphApi(
        {
          list: selectFileIds.value,
          graphCount,
        },
        cancelTokenOfGraphApi.token
      ).then(({ data }) => {
        try {
          nlpResult.graph = JSON.parse(data)
        } catch (e) {
          IS_DEV && console.error('**debug updateGraph JSON parse caught error:', e)
          nlpResult.graph = {
            nodes: [],
            links: [],
          }
        }
      }).finally(() => {
        graphIsLoading.value = false
      })
    }

    // TODO：统一变量命名
    const abstractLoading = ref(false) // 摘要loading

    const paramsOfAbstract = reactive<Pick<IFileRead.SummaryReqParams, 'summaryCount'>>({
      summaryCount: 500,
    })
    let cancelTokenOfAbstractApi = CancelToken.source()
    function onUpdateAbstractCount (count: number) {
      if (selectFileIds.value.length === 0) return

      abstractLoading.value = true
      cancelTokenOfAbstractApi.cancel()
      cancelTokenOfAbstractApi = CancelToken.source()
      getAbstractApi({ list: selectFileIds.value, summaryCount: count }, cancelTokenOfAbstractApi.token).then(({ data }) => {
        nlpResult.abstract = data ?? ''
        paramsOfAbstract.summaryCount = count
      }).finally(() => {
        abstractLoading.value = false
      })
    }

    // TODO：统一变量命名
    const paramsOfThemeWord = reactive<Pick<IFileRead.ThemeWordReqParams, 'keywordCount'>>({
      keywordCount: 10,
    })

    const keyWordLoading = ref(false) // 主题词loading

    let cancelTokenOfThemeWordApi = CancelToken.source()
    function onUpdateThemeWordCount (count: number) {
      if (selectFileIds.value.length === 0) return
      keyWordLoading.value = true
      cancelTokenOfThemeWordApi.cancel()
      cancelTokenOfThemeWordApi = CancelToken.source()
      getKeyWordApi({ list: selectFileIds.value, keywordCount: count }, cancelTokenOfThemeWordApi.token).then(({ data }) => {
        try {
          nlpResult.themeWords = JSON.parse(data)
        } catch (e) {
          IS_DEV && console.error('**debug onUpdateThemeWordCount JSON parse 错误:', e, 'data:', data)
          nlpResult.themeWords = []
        }
        paramsOfThemeWord.keywordCount = count
      }).finally(() => {
        keyWordLoading.value = false
      })
    }

    return {
      startNlpTask,
      graphIsLoading,
      abstractLoading,
      keyWordLoading,
      nlpResult,

      paramsOfAbstract,
      onUpdateAbstractCount,

      paramsOfThemeWord,
      onUpdateThemeWordCount
    }
  },
})
